import React from "react";
import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e) => {
    if (e.key === "Enter" && q.trim()) {
      navigate(`/search/${encodeURIComponent(q.trim())}`);
      setQ("");
    }
  };
  return (
    <nav className="navbar">
      <Link to="/" className="navbar__logo">
        Channel<span>MM</span>
      </Link>

      <ul className="navbar__links">
        <li><NavLink to="/" end>Home</NavLink></li>
        <li><NavLink to="/movies/page/1">Movies</NavLink></li>
        <li><NavLink to="/tv-shows/page/1">Series</NavLink></li>
        <li><NavLink to="/contact">Contact Us</NavLink></li>
      </ul>

      <div className="navbar__search">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input type="text"
          placeholder="Search movies, TV shows..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={handleSearch} />
      </div>
    </nav>
  );
}

export default Navbar;
